import classNames from 'classnames';
import P from 'components/ui/P';
import Cookies from 'js-cookie';
import { useLocale, useTranslations } from 'shared/hooks/i18n';
import Image from 'next/image';
import { FC } from 'react';
import { CookiesType, InterfaceLanguage } from 'types/enums';
import styles from './index.module.scss';
import { useUserContext } from 'context/user_state';
// import { useRouter } from 'next/navigation';
import { usePathname, useRouter } from 'i18n/navigation';

interface Props {
  language: InterfaceLanguage;
}

const SelectItem: FC<Props> = ({ language }) => {
  const t = useTranslations();
  const userContext = useUserContext();
  const lang = useLocale();
  const router = useRouter();
  const pathname = usePathname();

  const onClickLanguage = (lang: InterfaceLanguage) => {
    Cookies.set(CookiesType.locale, lang, { path: '/' });
    Cookies.set(CookiesType.isChangedLang, 'true');
    router.replace(pathname, { locale: lang });
  };

  return (
    <div
      className={classNames(styles.selectItem, { [styles.selectItem__active]: language === lang })}
      onClick={() => onClickLanguage(language)}>
      <div className={classNames(styles.select, { [styles.select__active]: language === lang })}>
        <div className={classNames({ [styles.hideSvg]: language !== lang })}>
          <Image src={'/icons/select.svg'} alt='select' width={20} height={20} />
        </div>
      </div>
      <Image src={`/icons/${language}-flag.svg`} alt='flag' width={20} height={20} />
      <P className={styles.title}>
        {t(`language_${language === InterfaceLanguage.Ukranian ? 'uk' : language}`)}
      </P>
    </div>
  );
};

export default SelectItem;
